import {
  cardiacLogoIcon,
  cardioOneLogoIcon,
  grupoCardiologicoBoskisLogoIcon,
} from '@/shared/ui/assets';
import { ORGANIZATION_SLUG } from '@/shared/config';
import { auth } from '@/shared/lib';

const LOGO_BY_SLUG = {
  [ORGANIZATION_SLUG.CARDIOLOGX]: cardiacLogoIcon,
  [ORGANIZATION_SLUG.CARDIO_ONE]: cardioOneLogoIcon,
  [ORGANIZATION_SLUG.GRUPO_CARDIOLOGICO_BOSKIS]: grupoCardiologicoBoskisLogoIcon,
};

/**
 * Header banner showing the logo of the signed-in user's organization. Reads the organization slug from auth.userOrganization and looks it up in LOGO_BY_SLUG, falling back to the Cardiac logo when the slug has no entry.
 *
 * @returns The rendered logo banner element.
 */
const LogoBanner = () => {
  const organization = auth.userOrganization();
  const { slug } = organization || {};
  const src = LOGO_BY_SLUG[slug] ?? cardiacLogoIcon;
  return (
    <div className="logo-banner-container">
      <div className="logo-banner">
        <img src={src} alt="" aria-hidden="true" />
      </div>
    </div>
  );
};

export default LogoBanner;
